<!-- 
	CreateNews
	props: User
  	role: Admin
	Called by @/views/AdminManageNews to create new news items for user display
  	Date function allows for future deployment of the message on the front end as well as removal after specified date
-->

<template>
	<div class="create-news">
		<div class="text-3xl">Create New News Item</div>
		<div v-if="error" class="alert -mt-4">
			<Alert>{{ error }}</Alert>
		</div>
		<form class="text-black" @submit.prevent="createNews">
			<div class="form-group">
				<input
					v-model="form.title"
					class="w-1/2"
					type="text"
					placeholder="Title"
					required
				/>
			</div>
			<div class="form-group">
				<textarea
					v-model="form.content"
					class="w-1/2"
					placeholder="Content"
					rows="10"
					required
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.hyperlink"
					class="w-1/2"
					type="url"
					placeholder="Hyperlink"
				/>
			</div>
			<div class="form-group">
				<input
					v-model="form.hyperlinkText"
					class="w-1/2"
					type="text"
					placeholder="Hyperlink Button Text"
				/>
			</div>
			<div class="form-group">
				<label for="publushDate" class="text-white">Publish Date</label>
				<br />
				<input
					v-model="form.publishDate"
					type="date"
					name="publishDate"
					id="date"
					required
				/>
			</div>
			<div class="form-group">
				<label for="removalDate" class="text-white">Removal Date</label>
				<br />
				<input
					v-model="form.removalDate"
					type="date"
					name="removalDate"
					id="date"
				/>
			</div>
			<CustomButton>Create News Item</CustomButton>
		</form>
	</div>
</template>
<script>
	import firebase from "firebase";

	import Alert from "@/components/Alert";
	import CustomButton from "@/components/CustomButton";

	export default {
		name: "CreateNews",
		props: ["user"],
		components: {
			CustomButton,
			Alert,
		},
		data() {
			return {
				form: {
					title: "",
					content: "",
					hyperlink: "",
					hyperlinkText: "",
					publishDate: "",
					removalDate: "",
				},
				error: null,
			};
		},
		methods: {
			createNews() {
				// create news item within the news collection on firestore
				const createdAt = new Date();

				const db = firebase.firestore();

				const newsData = {
					title: this.form.title,
					content: this.form.content,
					hyperlink: this.form.hyperlink,
					hyperlinkText: this.form.hyperlinkText,
					publishDate: this.form.publishDate,
					removalDate: this.form.removalDate,
					author: this.user.data.email,
					createdAt: createdAt,
				};

				db.collection("news").add(newsData);

				alert(`${this.form.title} has been created.`);

				this.form = {
					title: "",
					content: "",
					hyperlink: "",
					hyperlinkText: "",
					publishDate: "",
					removalDate: "",
				};
			},
		},
	};
</script>

<style scoped>
	.form-group {
		margin: 25px 0;
	}

	form .form-group input {
		border-bottom: 1px solid #ffffff;
		padding: 5px;
		background-color: transparent;
		color: #ffffff;
	}

	form .form-group textarea {
		border: 1px solid #ffffff;
		padding: 5px;
		background-color: transparent;
		color: #ffffff;
	}

	form .form-group #date {
		width: 170px;
	}

	form .form-group ::-webkit-calendar-picker-indicator {
		filter: invert(1);
	}
</style>
